module.exports = __webpack_public_path__ + "fonts/lato-v17-latin-700.1efbd38.woff2";